import { Consumer } from '../Context'
import Loader from './Loader'

export default function Auth() {
  return (
    <Consumer>
      {(props) => (
        <form onSubmit={props.handleAuth}>
          <div className="form-group">
            <input
              type="password"
              name="password"
              className="form-control"
              placeholder="Enter password"
              autoComplete="current-password"
              required
            />
          </div>
          <button
            type="submit"
            disabled={props.loading}
            className="d-flex btn btn-primary ml-auto px-5 button__load"
          >
            {props.loading ? <Loader /> : <span>Authenticate</span>}
          </button>
        </form>
      )}
    </Consumer>
  )
}
